import css from './WalletTickets.module.scss'
import React, { useEffect, useRef } from 'react'
import MediaQuery from 'react-responsive'

import { BreakpointsMaxWidth } from 'meta/layout/breakpoints'
import { IWalletEntityType, IWalletEvent } from 'meta/pages/v4/wallet'

import { Grid, GridContainer } from 'components/Layout/Grid'
import useOnScreen from 'components/Pages/Collection/InfoBox/Gallery/Images/Item/useOnScreen'

import Divider from '../Divider'
import WalletTicketCollectionDesktopContainer from './WalletTicketCollection/WalletTicketCollectionDesktopContainer'
import WalletTicketCollectionMobileContainer from './WalletTicketCollection/WalletTicketCollectionMobileContainer'
import WalletTicketDesktopContainer from './WalletTicketDesktop/WalletTicketDesktopContainer'
import WalletTicketMobileContainer from './WalletTicketMobile/WalletTicketMobileContainer'

interface Props {
  pastEvents: IWalletEvent[]
  upcomingEvents: IWalletEvent[]
  eventActive: number | null
  useLongCard: boolean
  setEventActive(eventId: number): void
  setUseLongCard(value: boolean): void
  setPastEventsVisible(value: boolean): void
}

const WalletTickets: React.FC<Props> = (props) => {
  const { pastEvents, upcomingEvents, eventActive, useLongCard, setEventActive, setUseLongCard, setPastEventsVisible } =
    props

  const pastEventsRef = useRef<HTMLDivElement>(null)
  const arePastEventsVisible = useOnScreen(pastEventsRef)

  useEffect(() => {
    if (arePastEventsVisible) {
      setPastEventsVisible(true)
    }
  }, [arePastEventsVisible])

  return (
    <>
      <MediaQuery maxWidth={BreakpointsMaxWidth.laptop}>
        {upcomingEvents && pastEvents && !pastEvents.some((e) => e.id === eventActive) && (
          <GridContainer className={css.tickets} style={{ height: eventActive ? (useLongCard ? 692 : 652) : 'auto' }}>
            {upcomingEvents.map((eventData) => {
              const Component =
                eventData.type === IWalletEntityType.event
                  ? WalletTicketMobileContainer
                  : WalletTicketCollectionMobileContainer

              return (
                <Component
                  key={eventData.id}
                  onClick={(eventId) => {
                    setEventActive(eventId)
                    setUseLongCard(true)
                  }}
                  //@ts-ignore
                  eventActive={eventActive}
                  useLongCard={useLongCard}
                  walletEventData={eventData}
                />
              )
            })}
          </GridContainer>
        )}

        {!eventActive && pastEvents && <Divider type="past" />}

        {pastEvents && upcomingEvents && !upcomingEvents.some((e) => e.id === eventActive) && (
          <GridContainer className={css.tickets} style={{ height: eventActive ? (useLongCard ? 692 : 652) : 'auto' }}>
            <div ref={pastEventsRef} />
            {pastEvents.map((eventData) => {
              const Component =
                eventData.type === IWalletEntityType.event
                  ? WalletTicketMobileContainer
                  : WalletTicketCollectionMobileContainer

              return (
                <Component
                  key={eventData.id}
                  onClick={(eventId) => {
                    setEventActive(eventId)
                    setUseLongCard(true)
                  }}
                  //@ts-ignore
                  eventActive={eventActive}
                  useLongCard={useLongCard}
                  walletEventData={eventData}
                  isPastEvent
                />
              )
            })}
          </GridContainer>
        )}
      </MediaQuery>

      <MediaQuery minWidth={BreakpointsMaxWidth.laptop}>
        <GridContainer>
          <Grid className={css.tickets}>
            {upcomingEvents &&
              upcomingEvents.length > 0 &&
              upcomingEvents.map((event, key) => {
                const Component =
                  event.type === IWalletEntityType.event
                    ? WalletTicketDesktopContainer
                    : WalletTicketCollectionDesktopContainer

                return <Component key={key} walletEventData={event} />
              })}
          </Grid>
        </GridContainer>

        {pastEvents && <Divider type="past" />}

        <GridContainer>
          {<div ref={pastEventsRef} />}
          <Grid className={css.tickets}>
            {pastEvents &&
              pastEvents.length > 0 &&
              pastEvents.map((event, key) => {
                const Component =
                  event.type === IWalletEntityType.event
                    ? WalletTicketDesktopContainer
                    : WalletTicketCollectionDesktopContainer

                return <Component key={key} walletEventData={event} />
              })}
          </Grid>
        </GridContainer>
      </MediaQuery>
    </>
  )
}

export default WalletTickets
